import React, { useState, useEffect } from 'react';
import FortuneTellingDetailComponent from './Detail.component';
import * as PublicProfileApi from 'api/student/v2/publicProfile.api';
import * as EventApi from 'api/student/v2/event.api';
import { getCurrentLangName } from 'helpers/String.helper';
import { getLanguageValue } from 'locales/i18n';
import { PAGE_TYPE } from 'enums';

const FortuneTellingDetailContainer: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingAnalysis, setIsLoadingAnalysis] = useState(false);
    const [profileImage, setProfileImage] = useState<any>(null);
    const [birthday, setBirthday] = useState<string | null>(null);
    const [gender, setGender] = useState<string | null>(null);
    const [sajuAnalysis, setSajuAnalysis] = useState<EventApi.ISajuAnalysis | null>(null);
    const [hasAnalysis, setHasAnalysis] = useState(false);

    useEffect(() => {
        fetchProfileInfo();
        fetchSajuAnalysis();
    }, []);

    const fetchProfileInfo = async () => {
        try {
            const result = await PublicProfileApi.getHomeInfo();
            
            if (result?.info) {
                const { info } = result;
                // 프로필 이미지 설정
                if (info.profileImageInfo) {
                    setProfileImage(info.profileImageInfo);
                }
                // 생년월일 설정
                if (info.birthday) {
                    setBirthday(info.birthday);
                }
                // 성별 설정
                if (info.genderTypeCodeInfo?.names) {
                    setGender(getCurrentLangName(info.genderTypeCodeInfo.names));
                }
            }
        } catch (error) {
            console.error('프로필 정보 조회 실패:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchSajuAnalysis = async () => {
        try {
            const result = await EventApi.getSajuAnalysis();
            
            if (result?.eventLog) {
                setSajuAnalysis(result.eventLog);
                setHasAnalysis(true);
            } else {
                setHasAnalysis(false);
                setSajuAnalysis(null);
            }
        } catch (error) {
            console.error('사주 관상 분석 조회 실패:', error);
            setHasAnalysis(false);
            setSajuAnalysis(null);
        }
    };

    const handleViewFortuneTelling = async () => {
        if (isLoadingAnalysis) return;
        
        try {
            setIsLoadingAnalysis(true);
            const result = await EventApi.createSajuAnalysis();
            
            if (result?.result && result?.sajuAnalysis) {
                setSajuAnalysis(result.sajuAnalysis);
                setHasAnalysis(true);
            } else {
                alert(getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtSajuFortuneTellingErrorCannotCreate"));
            }
        } catch (error) {
            console.error('사주 관상 분석 생성 실패:', error);
            alert(getLanguageValue(PAGE_TYPE.STUDENT, "hubMenu.txtSajuFortuneTellingErrorCreating"));
        } finally {
            setIsLoadingAnalysis(false);
        }
    };

    return (
        <FortuneTellingDetailComponent
            isLoading={isLoading}
            isLoadingAnalysis={isLoadingAnalysis}
            profileImage={profileImage}
            birthday={birthday}
            gender={gender}
            hasAnalysis={hasAnalysis}
            sajuAnalysis={sajuAnalysis}
            onViewFortuneTelling={handleViewFortuneTelling}
        />
    );
};

export default FortuneTellingDetailContainer;

